import { TStorage } from '@src/models/common';
import { isObject } from 'lodash';

export const getStorageUrl = (
  storageType: TStorage,
  fileName?: string | { [key: string]: unknown },
  thumb?: boolean,
) => {
  if (!fileName) {
    return '';
  }

  if (isObject(fileName)) {
    return fileName.mainUrl as string;
  }

  if (fileName.startsWith('https://')) {
    return fileName;
  }

  if (thumb) {
    switch (storageType) {
      case 'company-logo':
        return `https://cdn.centra.ai/company-logo/r/50x-/${fileName}`;
      case 'product-logo':
        return `https://cdn.centra.ai/product-logo/r/50x-/${fileName}`;
      case 'product-media':
        return `https://cdn.centra.ai/product-media/r/50x-/${fileName}`;
      case 'account-avatar':
        return `https://cdn.centra.ai/account-avatar/r/50x-/${fileName}`;
      default:
        return '';
    }
  } else {
    switch (storageType) {
      case 'company-logo':
        return `https://cdn.centra.ai/company-logo/o/${fileName}`;
      case 'product-logo':
        return `https://cdn.centra.ai/product-logo/o/${fileName}`;
      case 'product-media':
        return `https://cdn.centra.ai/product-media/o/${fileName}`;
      case 'account-avatar':
        return `https://cdn.centra.ai/account-avatar/o/${fileName}`;
      // return `${process.env.REACT_APP_ACCOUNT_AVATAR_STORAGE}${fileName}`
      default:
        return fileName;
    }
  }
};
